import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "examples/Sidenav";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";
import routes from "routes";
import { useMaterialUIController, setMiniSidenav } from "./context";
import brandWhite from "assets/images/logo.png";
import brandDark from "assets/images/logo1.png";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Backdrop } from "@mui/material/";
import "styles.css";
import { setBackdropOpen } from "features/commonSlice";
import {
  setStartDate, setEndDate, setDateSelectChosen, setDateVisible,
  setFirmListOptions, setFirmListData, setUserEuIdData, setFirmReportResponse,
  setSmsRows, setTypeReportRows,
  setMmsRows, setMediaMobileRows,
  setFirmReportRows, setFirmListSelectedOptions, setServices, setMessage, setAlertType
} from "features/firmReportSlice";

export default function App() {

  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    layout,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (isHome) return;
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (isHome) return;
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const dispatchHook = useDispatch();

  // for backdrop start
  window.addEventListener("backdropOpenStartEvent", () => {
    dispatchHook(setBackdropOpen(true));
  });

  window.addEventListener("backdropOpenEndEvent", () => {
    dispatchHook(setBackdropOpen(false));
  });

  const backdropOpen = useSelector(state => state.common.backdropOpen);

  // for backdrop end

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;

    let search = window.location.search;
    let params = new URLSearchParams(search);

    if ((pathname !== '/FirmaRaporu' && pathname !== '/FastDetayRaporu')) {
      if (!(pathname === '/GonderimRaporu' && params.size > 0)) {
        dispatchHook(setStartDate(new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + new Date().getDate()).slice(-2) + " 00:00:00"));
        dispatchHook(setEndDate(new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + new Date().getDate()).slice(-2) + " 23:59:59"));
        dispatchHook(setDateSelectChosen({ value: 'selectedDate', label: 'Seçili Tarih' }));
        dispatchHook(setDateVisible(true));
        dispatchHook(setFirmListOptions([]));
        dispatchHook(setFirmListData([]));
        //dispatchHook(setUserEuIdData([]));
        dispatchHook(setFirmReportResponse({
          customerAccountSummaryReportSMS: [],
          customerAccountOperatorSendTypeReport: [],
          customerAccountSummaryReportMMS: [],
          customerAccountSummaryReportMediaMobile: [],
          firmReport: []
        }));
        dispatchHook(setSmsRows([]));
        dispatchHook(setTypeReportRows([]));
        dispatchHook(setMmsRows([]));
        dispatchHook(setMediaMobileRows([]));
        dispatchHook(setFirmReportRows([]));
        dispatchHook(setFirmListSelectedOptions([]));
        dispatchHook(setServices(['BULKSMS']));
        dispatchHook(setMessage(""));
        dispatchHook(setAlertType(""));
      }
    }
  }, [pathname]);

  const getRoutes = allRoutes =>
    allRoutes.map(route => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <Sidenav
          color={sidenavColor}
          brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
          brandName='Codec WebRapor'
          routes={routes}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
      )}
      {layout === "vr"}

      <Backdrop
        style={{ position: "fixed", borderRadius: 10, marginTop: -24 }}
        sx={{ color: "#fff", zIndex: 10130 }}
        open={backdropOpen}
      >
        <CircularProgress color='inherit' />
      </Backdrop>

      <Routes>
        {getRoutes(routes)}
        <Route path='*' element={<Navigate to='/authentication/sign-in' />} />
      </Routes>
    </ThemeProvider>
  );
}